import ContractFilesTab from "@/src/components/organism/ContractFilesTab";

interface ContractFilesTabProps {
  tab: "list" | "gallery";
  onTabChange: (tab: ContractFilesTabProps["tab"]) => void;
}

const ExporterContractFilesTab = ({ tab, onTabChange }: ContractFilesTabProps) => {
  return (
    <ContractFilesTab 
      tab={tab} 
      onTabChange={onTabChange}
      userType="EXPORTER"
    />
  );
};

export default ExporterContractFilesTab;
